import React, { useEffect, useRef } from "react";
import { scrambleText } from "./scrambleText.js";
import "../styles/style.css"


const messages = [
  { delay: 0, text: "Coming Soon", size: "text-8xl", weight: "font-bold" },
  { delay: 800, text: ".", size: "text-6xl", weight: "font-bold" },
  { delay: 1600, text: ".", size: "text-6xl", weight: "font-bold" },
  { delay: 2400, text: ".", size: "text-6xl", weight: "font-bold" },

];

const Message = ({ text, delay, size, weight }) => {
  const ref = useRef();

  useEffect(() => {
    scrambleText(ref.current, text, { delay });
  }, [text, delay]);

  return <span ref={ref} className={`text-[#000000] ${size} ${weight} mb-4`}></span>;
};

const ComingSoon = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#FEF6E5] font-poppins">
      <div className="comingSoon ">
        <a  className="button_top">
        <div id="message ">
          {messages.map((message, index) => (
            <Message key={index} {...message} />
          ))}
        </div>
        </a>
        
        
      </div>
    </div>
  );
};

export default ComingSoon;
